"use strict";

import $ from "jquery";

function init() {
    $(".js-popup-module").each(function () {
        const $this = $(this);
        const settings = {
            impressionInteval: $this.data("popupImpressionInteval"),
            duration: $this.data("popupDuration"),
            delay: $this.data("popupDelay"),
            disappear: $this.data("popupDisappear"),
            maxImpression: $this.data("popupMaxImpression"),
            continueImpression: $this.data("popupContinueImpression"),
            popId: $this.data("popupId"),
            cookieName: "popup",
        };

        let durationTimer;
        let impressionIntevalTimer;
        let delayTimer;

        function cookieGet() {
            const cookieName = settings.cookieName + "_" + settings.popId;
            const ca = document.cookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === " ") {
                    c = c.substring(1, c.length);
                }

                if (c.indexOf(cookieName) === 0) {
                    return c.substring(cookieName.length + 1, c.length);
                }
            }

            return null;
        }

        function cookieSet() {
            const current =
                cookieGet() === null ? 0 : parseInt(cookieGet(), 10);
            const value = current + 1;
            const date = new Date();

            date.setTime(date.getTime() + 315532800000);
            document.cookie =
                settings.cookieName +
                "_" +
                settings.popId +
                "=" +
                value +
                "; expires=" +
                date.toGMTString() +
                "; path=/";
        }

        function openPopup() {
            $this.find(".js-popup-module__body").slideDown();
            $this
                .find(".popup-module__header")
                .addClass("js-popup-module__header--active");
        }

        function closePopup() {
            $this.find(".js-popup-module__body").slideUp();
            $this
                .find(".popup-module__header")
                .removeClass("js-popup-module__header--active");
        }

        function setDuration() {
            if (settings.duration > 0) {
                durationTimer = setTimeout(function () {
                    closePopup();
                    setImpressionIntaval(); // eslint-disable-line
                }, settings.duration);
            }
        }

        function setImpressionIntaval() {
            if (cookieGet() === null || cookieGet() < settings.maxImpression) {
                if (settings.impressionInteval > 0) {
                    impressionIntevalTimer = setTimeout(function () {
                        $this.fadeIn();
                        openPopup();
                        setDuration();
                    }, settings.impressionInteval);
                }

                if (settings.disappear) {
                    setTimeout(function () {
                        $this.fadeOut();
                    }, 500);
                }

                cookieSet();
            }
        }

        $this.on("mouseover", function () {
            clearTimeout(durationTimer);
            clearTimeout(impressionIntevalTimer);
        });

        $this.on("mouseleave", function () {
            if (
                $this
                    .find(".popup-module__header")
                    .hasClass("js-popup-module__header--active") &&
                !$this.find("input").is(":focus") &&
                !$this.hasClass("js-on-ajax")
            ) {
                setDuration();
            }
        });

        //
        if (cookieGet() === null || cookieGet() < settings.maxImpression) {
            if ($this.data("popupRun")) {
                openPopup();
                setDuration();
            } else if (settings.delay !== 0) {
                delayTimer = setTimeout(function () {
                    openPopup();
                    setDuration();
                }, settings.delay);
            }
        }

        $this.find(".popup-module__header").on("click", function () {
            if ($(this).hasClass("js-popup-module__header--active")) {
                closePopup();
                clearTimeout(delayTimer);
                clearTimeout(impressionIntevalTimer);
            } else {
                openPopup();
                clearTimeout(delayTimer);
                clearTimeout(impressionIntevalTimer);
            }
        });

        $this.find(".js-popup-ajax").submit(function () {
            const ajaxOptions = {
                method: $this.find(".js-popup-ajax").attr("method"),
                action: $this.find(".js-popup-ajax").attr("action"),
                data: $(this).serialize(),
            };

            $this.addClass("js-on-ajax");
            $this.find(".js-courses-loading").addClass("active");
            $this.find(".alert.alert--danger").addClass("u-hidden--all");

            $.ajax({
                method: ajaxOptions.method,
                action: ajaxOptions.action,
                data: ajaxOptions.data,
            })
                .done(function () {
                    $this.find(".js-popup-ajax").addClass("u-hidden--all");
                    $this
                        .find(".alert.alert--success")
                        .removeClass("u-hidden--all");

                    if (!settings.continueImpression) {
                        const date = new Date();
                        document.cookie =
                            settings.cookieName +
                            "=" +
                            settings.maxImpression +
                            "; expires=" +
                            date
                                .setTime(date.getTime() + 315532800000)
                                .toGMTString() +
                            "; path=/";
                    }
                })
                .fail(function () {
                    $this
                        .find(".alert.alert--danger")
                        .removeClass("u-hidden--all");
                })
                .always(function () {
                    $this.find(".js-courses-loading").removeClass("active");
                    $this.removeClass("js-on-ajax");
                });

            return false;
        });
    });
}

export default {
    init,
};
